'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _treatAdminForm = require('./treat-admin-form.component');

var _treatAdminForm2 = _interopRequireDefault(_treatAdminForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.treatAdminForm', []).component('treatAdminForm', _treatAdminForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/treat-admin-form/treat-admin-form.module.js